import BasicPaperDisplay from "../components/BasicPaperDisplay";
export default function AlreadyRedeemed() {
  return (
    <BasicPaperDisplay
      title={"Already redeemed"}
      body={<>The token(s) held in your wallet have already been redeemed.</>}
    />
  );
}
